import type { CartItem } from '@/features/totems/domain/model/cart-item';
import type { MenuSnapshotProduct } from '@/features/totems/domain/model/menu-snapshot';
import { getProductStockLimit } from '@/features/totems/domain/service/product-stock';
import { calculateCartItemTotal } from '@/features/totems/domain/service/totem-price';

export interface CartLineInfo {
  lineTotal: number;
  product: MenuSnapshotProduct | undefined;
  isAtStockLimit: boolean;
  hasOptions: boolean;
}

/** Derived data for one cart line: its total, its menu product, whether its stock is exhausted and whether it can be edited. */
export function getCartLineInfo(
  item: CartItem,
  cartItems: CartItem[],
  menuProducts: MenuSnapshotProduct[] | undefined
): CartLineInfo {
  const product = menuProducts?.find(p => p.id === item.productId);
  const stockLimit = getProductStockLimit(product?.product_stock);
  const totalProductQuantity = cartItems
    .filter(i => i.productId === item.productId)
    .reduce((sum, i) => sum + i.quantity, 0);

  return {
    lineTotal: calculateCartItemTotal(item),
    product,
    isAtStockLimit: totalProductQuantity >= stockLimit,
    hasOptions: item.subselections.length > 0 || (product?.product_subselection?.length ?? 0) > 0,
  };
}
